import ZingTouch from 'zingtouch';
import gsap from 'gsap';
import { getCardinalDirection } from '../helpers/ZingTouchHelper';



/* 
 * 
 */
export default class HorizontalList {
	#wrapper; 
	#touchableEl;
	#effectEl;
	#elements;
	#itemWidth;
	#realWidth;
	#track;
	#position = 1;
	
	/*
	 * 
	 */
	constructor(wrapper, touchableEl, effectEl, itemsSelector) {
		this.#wrapper = wrapper;
		this.#touchableEl = touchableEl;
		this.#effectEl =  effectEl;
		this.#elements = Array.from(this.#wrapper.querySelectorAll(itemsSelector));
		this.getRealWidth();
		this.bindEvents();
	}
	
	
	
	
	/*
	 * 
	 */
	attachTrack(track) {
		if(! track ) {
			return;
		}
		
		const _this = this;
		this.#track = track;
		this.#track.onChange(percentage => {
			const { min } = _this.getBounds();
			const _x = (min / 100) * percentage;
			_this.setPosition(_x);
		});
		
		
		//const bounds = _this.getBounds();
		const x = gsap.getProperty(this.#effectEl, 'x');
		const ratio = this.#effectEl.offsetWidth / this.#realWidth;
		const diff = this.#realWidth - this.#effectEl.offsetWidth;
		const percentage = ((x * -1) / diff) * 100;
		
		_this.#track.setScrollWidth(`${ratio * 100}%`);
		_this.#track.setPercentage(percentage);
	}
	
	
	/*
	 * 
	 */
	getRealWidth() {
		let _width = 0;
		if( this.#elements.length === 0 ) {
			return 0;
		}
	
		this.#itemWidth = this.#elements[0].offsetWidth;
		this.#elements.forEach(i => _width += i.offsetWidth);
		this.#realWidth = _width;
		return _width;
	}
	
	
	/*
	 * 
	 */
	getBounds() {
		const min = this.#effectEl.offsetWidth - this.#realWidth;
		const max = 0;
		return { min, max };
	}
	
	
	/*
	 * 
	 */
	bindEvents() {
		const _this = this;
		const region = ZingTouch.Region(this.#wrapper, false, false);
		
		
		window.addEventListener('resize', () => _this.getRealWidth());
		
		const panEvent = new ZingTouch.Pan({
			numInputs: 1,
			threshold: 50,
		});
		
		region.bind(this.#touchableEl, panEvent, event => {
			const { currentDirection } = event.detail.data[0];
			const direction = getCardinalDirection(currentDirection);
			
			if( direction === 'W' || direction === 'E' ) {
				_this.moveTo(direction);
				event.detail.events.forEach(e => e.originalEvent.preventDefault());
				return;
			}
		}, false);
	}
	
	
	/*
	 * 
	 */
	moveTo(direction) {
		if( direction === 'W' || direction === 'E' ) {
			const viewWidth = this.#effectEl.offsetWidth;
			const visibleItems = Math.floor(viewWidth / (this.#itemWidth - 1)); // let 1 pixel of approx
			const distance = visibleItems * this.#itemWidth;
			const factor = direction === 'W' ? -1 : 1;
			this.setPosition(this.#position + (distance * factor));
			return;
		}
	}
	
	
	/*
	 * 
	 */
	setPosition(pos) {
		const _this = this;
		const bounds = _this.getBounds();
		const x = gsap.utils.clamp(bounds.min, bounds.max, pos);
		const diff = this.#realWidth - this.#effectEl.offsetWidth;
		const percentage = ((x * -1) / diff) * 100;
			
		gsap.to(_this.#effectEl, { 
			x: x,
			duration: .5, 
			onStart: () => _this.#track && _this.#track.setPercentage(percentage),
		});
		
		this.#position = pos;
	}
}
